<template>
  <!-- The ghost button is display:flex; a flex row keeps it at its content width instead of the cell width. -->
  <div class="tw-flex">
    <WdsButtonGhost
      v-if="placementsUrl"
      secondary
      :href="placementsUrl"
      :data-test="`supplier-placements-${rowIndex}`"
    >
      {{ column.hiresCount.toLocaleString() }}
    </WdsButtonGhost>
    <WdsText
      v-else
      :secondary="column.hiresCount === 0"
      :data-test="`supplier-placements-${rowIndex}`"
    >
      {{ column.hiresCount.toLocaleString() }}
    </WdsText>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsButtonGhost, WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { sharedPlacementsUrl } from '@/components/Clients/placementFilters'

const SupplierPlacementsColumn = graphql(`
  fragment SupplierPlacementsColumn on SupplierClient {
    id
    hiresCount
    client {
      id
      name
    }
    supplier {
      __typename
      id
      name
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof SupplierPlacementsColumn>
  rowIndex?: number
}>()

const column = computed(() => useFragment(SupplierPlacementsColumn, props.row))
const rowIndex = computed(() => props.rowIndex ?? 0)

// The placements page filters agencies by Recruiter id; a company supplier has no such filter.
const placementsUrl = computed(() =>
  column.value.hiresCount > 0 && column.value.supplier.__typename === 'Recruiter'
    ? sharedPlacementsUrl(column.value.client, column.value.supplier)
    : null,
)
</script>
